import * as ActionTypes from 'modules/lockers/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = [];

const resetState = () => initialState;

const setLockersIds = (_, { payload }) => payload.content.map(({ id }) => id);

const deleteVault = (state, { payload: locker }) => state.filter(id => id !== locker.id);

export default createReducer(initialState, {
  [ActionTypes.GET_LOCKERS_SUCCESS]: setLockersIds,
  [ActionTypes.GET_LOCKERS_FAILURE]: resetState,
  [ActionTypes.DELETE_LOCKER_SUCCESS]: deleteVault,
});
